var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
} 

// sticky top bar
// $(window).scroll(function(){
//   if ($(this).scrollTop() > 1) {
//       $('.ABZ-Announcement-Marquee, .section-announcement-bar-abz-bg-color').addClass('fixed');
//   } else {
//       $('.ABZ-Announcement-Marquee, .section-announcement-bar-abz-bg-color').removeClass('fixed');
//   }
// });

// abz-announcement
$(document).ready(function () {
  $('#abz-announcement').owlCarousel({
    loop: true,
    autoplay: true,
    dots: false,
    nav: false,
    slideTransition: 'linear',
    autoplayTimeout: 5000,
    smartSpeed: 1000,
    autoplayHoverPause: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
      },
      480: {
        items: 1,
      },
      1000: {
        items: 3
      }
    }
  });

  // abz-product-text-slider
  $('#abz-product-text-slider').owlCarousel({
    loop: true,
    nav: false,
    dots: false,
    margin: 28,
    slideTransition: 'linear',
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1.5
      },
      480: {
        items: 2.5
      },
      1000: {
        items: 3.5
      },
      1200: {
        items: 3,
      }
    } 
  });

  // abz-product-text-slider2
  $('#abz-product-text-slider2').owlCarousel({
    loop: true,
    nav: false,
    dots: false,
    margin: 28,
    slideTransition: 'linear',
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1
      },
      480: {
        items: 2
      },
      1000: {
        items: 3
      },
      1200: {
        items: 3,
      }
    }
  });

  $('#slide-testimonal').owlCarousel({
    margin: 0,
    center: true,
    loop: true,
    nav: false,
    autoplay: true,
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 2,
        margin: 15,
      },
      1000: {
        items: 3,
      }
    }
  });

  // abz-testislider
  $('.abz-testislider').owlCarousel({
    margin: 0,
    center: true,
    loop: true,
    nav: true,
    dots: true,
    autoplay: false,
    responsive: {
      0: {
        items: 1,
        autoHeight: true,
      },
      768: {
        items: 1,
      },
      1000: {
        items: 1,
      }
    }
  });

  // abz-featured-slider
  $('.abz-featured-slider').owlCarousel({
    loop: true,
    nav: false,
    rewind: true,
    dots: false,
    margin: 28,
    slideTransition: 'linear',
    autoplay: true,
    autoplayTimeout: 3000,
    smartSpeed: 800,
    autoplayHoverPause: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1.5
      },
      480: {
        items: 2.5
      },
      1025: {
        items: 3.5
      },
      1200: {
        items: 3,
      }
    }
  });

  // product-media-modal__content
  $('.product-media-modal__content').slick({
    slidesToShow: 1,
    infinite: false,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true
        }
      }
    ]
  });

});

$(document).ready(function () {
  $(".owl-prev").html('<img src="https://cdn.shopify.com/s/files/1/0610/9206/9529/files/prev.png?v=1677746377" alt="arrow-left">');
  $(".owl-next").html('<img src="https://cdn.shopify.com/s/files/1/0610/9206/9529/files/next.png?v=1677746377" alt="arrow-right">');
});



// Cart Drawer
class CartSuggestions extends HTMLElement {
  constructor() {
    super();
    this.dataset.empty == 'false' ? this.init() : '';
  }

  async init() {
    const res = await fetch(this.dataset.url);
    const resHTML = await res.text();
    const html = document.createElement('div');
    html.innerHTML = resHTML;
    const recommendations = html.querySelector('api-cart-suggestions');

    if (recommendations && recommendations.innerHTML.trim().length) {
      this.innerHTML = recommendations.innerHTML;
      window.onload = this.slicksuggestions();
    }
  }

  slicksuggestions() {
    $('.cart-suggestions').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: true,
      prevArrow: $('cart-suggestions .suggestions-prev'),
      nextArrow: $('cart-suggestions .suggestions-next')
    });

    document.querySelectorAll('[rcs]').forEach((rcs) => rcs.addEventListener('click', () => {
      $('.cart-suggestions').slick('refresh');
      this.querySelector('.cart-suggestions').scrollIntoView();
    }))
  }
}
customElements.define('cart-suggestions', CartSuggestions);


// General
class CustomQuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    this.section = this.closest('.shopify-section');
    this.bundleCard = this.closest('.bundle-card');
    this.status = this.section.querySelector(`.bundle-status[data-product="${this.dataset.product}"]`);
    this.statusText = this.section.querySelector(`.bundle-status-text[data-product="${this.dataset.product}"]`);

    this.checkZero();
  }

  checkZero() {
    this.input.value == 0 ? this.classList.add('zero') : this.classList.remove('zero');
    if (!this.bundleCard) return;
    this.input.value == 0 ? this.bundleCard.classList.add('zero') : this.bundleCard.classList.remove('zero');
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    this.checkZero();
    this.status ? this.status.dataset.quantity = this.input.value : null;
    this.statusText ? this.statusText.dataset.quantity = this.input.value : null;
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('custom-quantity-input', CustomQuantityInput);

// ABZ Bundle.liquid
if (typeof window.SealSubs !== 'undefined' && typeof window.SealSubs.refresh === 'function') {
  window.SealSubs.refresh();
}

function setFeaturedPrice(section) {
  if (!section) return;
  let atc = section.querySelector('.product-form__submit');

  var totalQuantity = 0;
  $(section).find('.quantity__input').each(function () {
    totalQuantity += parseInt($(this).val());
  });

  let minQuantity = section.dataset.minQuantity || 1;

  if (atc && totalQuantity < minQuantity) {
    atc.setAttribute('disabled', '');
    atc.dataset.remaining = minQuantity - totalQuantity;
  } else {
    atc.removeAttribute('disabled');
  }

  let totalEm = section.querySelector('.featured-total');
  if (totalEm) totalEm.textContent = ((totalQuantity * totalEm.dataset.price) / 100).toFixed(2);
}

// This event will be fired whenever a different subscription option is selected
document.addEventListener('sealsubs:price_update', function (e) {
  let em = e.detail.element;
  let section = em.closest('.abz-bundle');
  if (!section) return;

  let totalEm = section.querySelector('.featured-total');
  if (totalEm) {
    totalEm.dataset.price = e.detail.price;
    setFeaturedPrice(section);
  }
});

$('.abz-bundle .quantity__input').change(function (e) {
  let section = e.target.closest('.abz-bundle');
  let mainElm = e.target.closest('custom-quantity-input');

  (mainElm && e.target.value == 0) ? mainElm.classList.add('zero') : mainElm.classList.remove('zero');
  setFeaturedPrice(section);
});

$('.abz-bundle [name="quantity_option"]').change(function (e) {
  let section = e.currentTarget.closest('.abz-bundle');
  section.dataset.minQuantity = e.currentTarget.value;
  let label = section.querySelector('.quantity-options-label');
  label && (label.dataset.pack = e.currentTarget.dataset.pack);
  setFeaturedPrice(section);
});

document.querySelectorAll('.abz-bundle').forEach(section => {
  let featuredQuantity = section.querySelector('.quantity__input');
  featuredQuantity && featuredQuantity.dispatchEvent(new Event("change"));

  let quantity_option = section.querySelector('[name="quantity_option"]:checked');
  quantity_option && quantity_option.dispatchEvent(new Event("change"));
})

// ABZ Mobile Menu
var image = $(".abz-shop-image").html();
$(".menu-drawer__navigation > ul > li:nth-child(5)").append(image);

// PDP Page
function abzSliderButtons(btn, mediaCount) {
  const thumbSlider = btn.closest('media-gallery').querySelector('.slider.thumbnail-list');
  const currentThumb = thumbSlider.querySelector('[aria-current="true"]');
  const currentMedia = parseInt(currentThumb.parentElement.dataset.mediaPosition);
  let nextMedia;

  if (btn.name == 'abz-next') { (currentMedia >= mediaCount) ? nextMedia = 1 : nextMedia = currentMedia + 1; }
  else if (btn.name == 'abz-prev') { (currentMedia <= 1) ? nextMedia = mediaCount : nextMedia = currentMedia - 1; }

  nextMedia ? thumbSlider.querySelector(`[data-media-position="${nextMedia}"] .thumbnail`).click() : console.log('ktest');
}


// Sticky Add To Cart

$(window).scroll(function () {
  if ($(window).scrollTop() >= 730) {
    $('.sticky-section').addClass('fixed');
  }
  else {
    $('.sticky-section').removeClass('fixed');
  }
});

// Smooth auto scroll slider
document.addEventListener('DOMContentLoaded', function () {
  new Splide('.splide', {
    type: 'loop',
    drag: 'free',
    focus: 'center',
    arrows: false,
    autoWidth: true,
    pagination: false,
    perPage: 4,
    autoScroll: {
      speed: 0,
    },
  }).mount(window.splide.Extensions);
});

// Smooth auto scroll slider
document.addEventListener('DOMContentLoaded', function () {
  new Splide('#smoothscroll', {
    type: 'loop',
    drag: 'free',
    focus: 'center',
    arrows: false,
    autoWidth: true,
    pagination: false,
    perPage: 4,
    autoScroll: {
      speed: 0,
    },
  }).mount(window.splide.Extensions);
});

